/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const YoutubeLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M19.6 7a.8.8 0 0 0-.53-.6C18.63 6.28 16.5 6 12 6s-6.63.28-7.07.4a.8.8 0 0 0-.54.6C4.3 7.42 4 9.2 4 12s.29 4.58.4 5c.07.3.29.53.53.6.44.12 2.57.4 7.07.4s6.63-.28 7.07-.4c.24-.07.46-.3.54-.6.1-.42.39-2.2.39-5s-.28-4.58-.4-5m1.94-.5C22 8.28 22 12 22 12s0 3.72-.46 5.5a2.8 2.8 0 0 1-1.93 2.02C17.9 20 12 20 12 20s-5.9 0-7.6-.48a2.8 2.8 0 0 1-1.94-2.02C2 15.72 2 12 2 12s0-3.72.46-5.5a2.8 2.8 0 0 1 1.93-2.02C6.11 4 12 4 12 4s5.9 0 7.6.48a2.8 2.8 0 0 1 1.94 2.02M10 15.5v-7l6 3.5z" />
  </Icon>
);
